const userAddEditModal = Router.getController('users.userAddEditModal');
const menuController = Router.getController('customer.account.menuController');
const tableEl = $('.user-accounts-table');

usersTable = tableEl.DataTable({
  processing: false,
  serverSide: true,
  ajax: loadOrganizationUsersDatatableUrl,
  pageLength: 15,
  lengthChange: false,
  order: [],
  searching: false,
  ordering: false,
  paging: false,
  info: false,
  columns: [
    { data: 'user_name', orderable: false },
    { data: 'email', orderable: false },
    { data: 'is_billing', className: 'text-center', render: (isBilling, type, row) => `
          <input ${isBilling ? 'checked' : ''}
          id="billing-${row.id}"
          name="billing-${row.id}"
          type="checkbox">
                                        
          <label class="billingSwitch" for="billing-${row.id}"><span></span></label>
          <img style="display: none;" src="/img/cube.gif">
        ` },
    { data: 'is_newsletter', className: 'text-center', orderable: false, render: (isNewsletter, type, row) => `
          <input ${isNewsletter ? 'checked' : ''}
          id="newsletter-${row.id}"
          name="newsletter-${row.id}"
          type="checkbox">
                                        
          <label class="newsletterSwitch" for="newsletter-${row.id}"><span></span></label>
          <img style="display: none;" src="/img/cube.gif">
        ` },
    { name: 'action', className: 'action text-right', orderable: false, render: (data, type, row) => {
      const hidden = row.is_billing ? 'style="display: none"' : '';

      return `
          <button data-id-user="${row.id}" type="button" class="btn btn-purple invite" title="${__('Send Invite')}" ${hidden}><i class="fa fa-envelope fa-fw"></i></button>
          <button data-id-user="${row.id}" type="button" class="btn btn-purple edit" title="${__('Edit user')}"><i class="fa fa-pencil fa-fw"></i></button>
          <button data-id-user="${row.id}" type="button" style="color: #fff;" class="btn btn-danger delete" title="${__('Delete')}"><i class="fa fa-trash fa-fw"></i></button>
        `;
    } }
  ]
});

userAddEditModal.onUserAdded(() => {
  usersTable.ajax.reload();
});

userAddEditModal.onUserUpdated(() => {
  usersTable.ajax.reload();
});

userAddEditModal.onUserDeleted(() => {
  usersTable.ajax.reload();
});

menuController.onActivated('userAccounts', () => {
  if (usersTable) {
    usersTable.columns.adjust().draw();
  }
});

tableEl.delegate('button.edit', 'click', function (e) {
  const btn = $(this);
  const id = btn.data('id-user');
  btn.loading();

  userAddEditModal.show({ userId: id, hideUsers: true }, () => {
    btn.loading('reset');
  });

  e.preventDefault();
});

tableEl.delegate('button.delete', 'click', function (e) {
  const btn = $(this);
  const idUser = btn.data('id-user');
  btn.loading();

  bootbox.confirm({
    title: __('Delete user'),
    message: __('Do you want to delete selected user? This cannot be undone.'),
    buttons: {
      cancel: {
        label: `<i class="fa fa-times"></i> ${__('Cancel')}`,
        className: 'btn btn-light-purple'
      },
      confirm: {
        label: `<i class="fa fa-check"></i> ${__('Delete')}`,
        className: 'btn-light-purple btn btn-space'
      }
    },
    callback(result) {
      if (result) {
        $.post(deleteUserUrl, {
          id: idUser
        }, (data, b) => {
          btn.loading('reset');
          if (data.isError == 1) {
            toastr.error(data.msgError, 'Error');
          } else {
            btn.parent().parent().fadeOut(300, function () {
              $(this).remove();
              toastr.success(__('User has been deleted.'), __('Success'));
            });
          }
        });
      } else {
        btn.loading('reset');
      }
    }
  });

  e.preventDefault();
});

$('button.add').click(function (e) {
  const btn = $(this);
  btn.loading();

  userAddEditModal.show({ userId: 'new', hideUsers: true }, () => {
    btn.loading('reset');
  });

  e.preventDefault();
});

tableEl.delegate('button.invite', 'click', function (e) {
  const btn = $(this);
  const idUser = btn.data('id-user');

  btn.loading();

  bootbox.confirm({
    title: __('Send invitation'),
    message: __('Do you want to send invitation to selected user?'),
    buttons: {
      cancel: {
        label: `<i class="fa fa-times"></i> ${__('Cancel')}`,
        className: 'btn btn-light-purple'
      },
      confirm: {
        label: `<i class="fa fa-check"></i> ${__('Send Invitation')}`,
        className: 'btn btn-purple'
      }
    },
    callback(result) {
      if (result) {
        $.post(sendInvitationUrl, { idUser }, () => {
          btn.loading('reset');
          toastr.success(__('Invitation has been sent'));
        });
      } else {
        btn.loading('reset');
      }
    }
  });
});

tableEl.delegate('.billingSwitch', 'click', function (e) {
  const label = $(this);
  const checkbox = label.parent().find('input');
  const idUser = checkbox.attr('id').split('-')[1];

  label.hide();
  label.parent().find('img').show();

  $.post(switchBillingUrl, {
    idUser
  }, (data, b) => {
    label.show();
    label.parent().find('img').hide();

    if (data.isError == 1) {
      toastr.error(data.msgError, 'Error');
    } else if (data.checked) {
      checkbox.attr('checked', true);
      checkbox.parent().parent().find('.invite').hide();
    } else {
      checkbox.attr('checked', false);
      checkbox.parent().parent().find('.invite').show();
    }
  });
});

tableEl.delegate('.newsletterSwitch', 'click', function (e) {
  const label = $(this);
  const checkbox = label.parent().find('input');
  const idUser = checkbox.attr('id').split('-')[1];

  label.hide();
  label.parent().find('img').show();

  $.post(switchNewsletterUrl, {
    idUser
  }, (data, b) => {
    label.show();
    label.parent().find('img').hide();

    if (data.checked) {
      checkbox.attr('checked', true);
    } else {
      checkbox.attr('checked', false);
    }
  });
});
